import { StyleSheet } from 'react-native';
import { createOutsetShadow } from 'app/design/outset-shadow';

export const swipeTutorialStyles = StyleSheet.create({
  nextCard: {
    position: 'absolute',
    top: -8,
    right: 16,
    bottom: 8,
    left: 16,
    zIndex: 0,
  },
  foregroundCard: { zIndex: 1 },
  miniCard: {
    position: 'absolute',
    width: 54,
    height: 75,
    borderRadius: 9,
    borderWidth: 0.75,
    borderColor: '#25252629',
    backgroundColor: '#FFFFFF',
    ...createOutsetShadow({ offsetY: 2, radius: 3.5, color: 'rgba(40, 39, 37, 0.16)', androidElevation: 3 }),
  },
  demoCard: {
    position: 'absolute',
    width: 80,
    height: 96,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    ...createOutsetShadow({ offsetY: 2, radius: 3.5, color: 'rgba(40, 39, 37, 0.16)', androidElevation: 3 }),
  },
});
